//#region DevExtreme Imports

import 'devextreme/ui/toolbar'
import 'devextreme/ui/popup'

//#endregion

import { USER_SESSION_SERVICE_NAME } from "../../../../../../services/user-session"
import { ConfirmOrderDepositoryController } from "./confirm-order-depository.controller";
import { ORDER_SERVICE_NAME } from '../../../../../../services/order'
import { ORDER_CONFIRM_SERVICE_NAME } from '../../../../../../services/order/order.confirm.service'

export const COMPONENT_NAME: string = 'confirmOrderDepository'

//#region Asset Imports

import * as TEMPLATE from './confirm-order-depository.tpl.html'
import './confirm-order-depository.scss'

//#endregion

export class ConfirmOrderDepositoryComponent {

    controller = [
        ORDER_SERVICE_NAME,
        ORDER_CONFIRM_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME,
        ConfirmOrderDepositoryController
    ]

    bindings = {
        options: '<',
    } as { [index: string]: string }

    template = TEMPLATE

}